import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../localization/react'

const EmptyListingResult = () => {
  return (
    <Stack justifyContent="center" spacing={4}>
      <Heading is="h2" variant="small">
        <Localized id="empty-list-result-title" />
      </Heading>
      <Text variant="small" sx={{ color: 'darkgray' }}>
        <Localized id="empty-list-result-description" />
      </Text>
      {/* <Button variant="secondary" onClick={() => dispatch({ type: 'RESET_FILTERS' })}>
          Reset all filters
      </Button> */}
    </Stack>
  )
}

export default EmptyListingResult
